import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { InnerNavigationOption } from '../../event-management/types';

@Component({
  selector: 'app-cms-entity-management-inner-section-nav',
  templateUrl: './cms-entity-management-inner-section-nav.component.html',
  styleUrls: ['./cms-entity-management-inner-section-nav.component.scss'],
})
export class CmsEntityManagementInnerSectionNavComponent implements OnChanges {
  protected readonly Object = Object;

  @Input() activeOption: string;
  @Input() fragmentChangeScrolling: boolean;
  @Input() options: InnerNavigationOption[] = [];
  @Output()
  navigateTo: EventEmitter<string> = new EventEmitter<string>();

  @HostListener('window:scroll', ['$event'])
  onScroll(): void {
    if (this.fragmentChangeScrolling) {
      return;
    }

    const navPositions: Record<string, number> = {};

    this.options.forEach((step) => {
      const elem = document.getElementById(step.id);

      if (elem) {
        const { top } = elem.getBoundingClientRect();
        navPositions[step.id] = top;
      }
    });

    const scrollThreshold = window.innerHeight * 0.5;

    if (
      Math.round(
        document.body.scrollHeight - window.innerHeight - window.scrollY
      ) < 40
    ) {
      this.innerActiveOption = this.options[this.options.length - 1].id;
    } else if (window.scrollY < scrollThreshold) {
      this.innerActiveOption = this.options[0].id;
    } else {
      const newNavOption = Object.entries(navPositions).find(
        ([key, val]) =>
          (val > 0 && val < scrollThreshold) || (val < 0 && val > 40 && key)
      )?.[0];

      if (newNavOption) {
        this.innerActiveOption = newNavOption;
      }
    }
  }

  public innerActiveOption: string;

  ngOnChanges({ activeOption }: SimpleChanges): void {
    if (activeOption?.currentValue) {
      this.innerActiveOption = activeOption.currentValue;
    }
  }
}
